import { useEffect, useState } from 'react';

const skills = [
  { name: 'ASP.NET Core', desc: 'Canvas for robust, high-performance web applications' },
  { name: 'Azure DevOps', desc: 'Orchestrating seamless development pipelines' },
  { name: 'Blazor', desc: 'Crafting beautiful and responsive UIs with C#' },
  { name: 'C#', desc: 'Elegant, efficient, and maintainable code' },
  { name: 'Git', desc: 'Collaborative and version-controlled development' },
  { name: 'SQL Server', desc: 'Trusted data storage and management' },
];

const technologies = [
  'Microservices', 'EF Core', 'JavaScript', 'MVC', 'Azure',
  'DevOps', 'Blazor', 'WCF', 'Web API', 'Sitecore',
];

const palette = ['204,15,53', '220,38,38', '185,28,28', '239,68,68'];

const randomColor = () => {
  const c = palette[Math.floor(Math.random() * palette.length)];
  const o = (Math.floor(Math.random() * 5) + 5) / 10;
  return `rgba(${c},${o})`;
};

const buildColorMap = (): Record<string, string> => {
  const map: Record<string, string> = {};
  technologies.forEach(t => { map[t] = randomColor(); });
  return map;
};

const Devportfolio = () => {
  const [techColors, setTechColors] = useState<Record<string, string>>(buildColorMap);

  useEffect(() => {
    const timer = setInterval(() => setTechColors(buildColorMap), 800);
    return () => clearInterval(timer);
  }, []);

  return (
    <div>
      <p className="text-red-500 font-mono text-xs uppercase tracking-widest text-center mb-3">Development</p>
      <h3 className="text-2xl font-bold text-white text-center mb-10">A Symphony of Skills</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
        {skills.map(skill => (
          <div key={skill.name} className="bg-neutral-900 border border-neutral-800 hover:border-red-900 p-5 transition-colors duration-200">
            <p className="text-red-500 font-bold font-mono text-sm mb-2">{skill.name}</p>
            <p className="text-gray-400 text-sm leading-relaxed">{skill.desc}</p>
          </div>
        ))}
      </div>

      <p className="text-gray-500 text-center text-sm font-mono mb-5">
        Other technologies I have experience with:
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        {technologies.map(tech => (
          <span
            key={tech}
            style={{ color: techColors[tech] }}
            className="font-mono font-bold text-sm transition-colors duration-700"
          >
            {tech}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Devportfolio;
